import * as React from "react";
import type { SVGProps } from "react";
const SvgCurrencyCoinRubel = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9.327 16.8V7.2h4.582c.608 0 1.19.217 1.62.603.43.385.671.909.671 1.454 0 .546-.241 1.069-.671 1.455a2.43 2.43 0 0 1-1.62.602H7.8m6.11 2.743H7.8M21.6 12a9.6 9.6 0 1 1-19.2 0 9.6 9.6 0 1 1 19.2 0"
    />
  </svg>
);
export default SvgCurrencyCoinRubel;
